import { t } from '@delphire/fp'
import { Timestamps } from '../data'
import { Link } from '../link'

export type Type = t.TypeOf<typeof codec>

export const name = 'LibraryItem'

export const props = {
  ...Link.props,
  ...Timestamps.propsFromISOString,
  order: t.nullable(t.number),
  iconResourceId: t.nullable(t.string)
}

export const codec = t.strict(props, name)

export const codecRecord = t.record(t.string, codec)

export const codecRecordFromNullable = t.fromNullable(codecRecord, {})
